import { Dropdown, Spinner } from "react-bootstrap";
import ImageLoader from "../../../Common/ImageLoader";
import SlidingModal from "../../../CustomModal/SlidingModal";
import "./index.styles.scss";
import ThreeDotsIcon from "../../../icons/three-dots.icon";
import ProductDetailsForm, { addPeriodToDate } from "./product-details.form";
import { useEffect, useState } from "react";
import { getAPIData, getPageDataApi, postData } from "../../../../Utils/commonApi";
import { useAuth } from "../../../context/Auth";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import OrderSummary from "../../../Common/loader";
import integrationUtils from "../../../../Utils/integration.utils";

const AddToolModal = ({
  technologyEnum = 0,
  setLoading = () => { },
  getPageData = () => { },
  show,
  mspId,
  hideModal,
  reportId = 0,
  selectedMSP = {},
  modalData = {},
  setModalData
}) => {
  const { authTokens } = useAuth();
  const { tool } = modalData;
  const [allModalData, setAllModalData] = useState({});
  const [multiTechnologyList, setMultiTechnologyList] = useState({});
  const [modalLoading, setModalLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (show) {
      getTechnologyList();
      getToolData();
    }
  }, [show])

  async function getTechnologyList() {
    await getAPIData(22, authTokens, {
      optionEnum1: tool?.ToolId ?? tool?.IntegrationId,
      optionEnum2: mspId,
      optionEnum3: technologyEnum ?? 1,
    }).then((response) => {
      if (response?.mr?.Success) {
        setMultiTechnologyList(response?.IntegrationTechnologyType_List);
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
    });
  }

  async function refreshTaxList({ taxId }) {
    await getAPIData(17, authTokens, {
      optionEnum1: reportId,
      optionEnum2: technologyEnum ?? 1, 
      optionEnum3: tool?.ToolId ?? tool?.IntegrationId,
      optionEnum4: mspId ?? selectedMSP?.MSPId ?? 0,
    }).then((response) => {
      if (response?.mr?.Success) {
        const defaultTax = response?.TaxRates?.find((f) => f.IsDefault);
        setAllModalData(prev => ({
          ...prev,
          TaxRates: response?.TaxRates,
          TaxRates_Selected: response?.TaxRates?.find((f) => f.ObjectId === taxId) ?? defaultTax ?? response?.TaxRates[0]
        }));
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
    });
  }

  async function getToolData() {
    setModalLoading(true);
    await getAPIData(17, authTokens, {
      optionEnum1: /*mspId ?? selectedMSP?.MSPId*/reportId,
      optionEnum2: technologyEnum ?? 1, 
      optionEnum3: tool?.ToolId ?? tool?.IntegrationId,
      optionEnum4: mspId ?? selectedMSP?.MSPId ?? 0,
    }).then((response) => {
      if (response?.mr?.Success) {
        setAllModalData(response);


        if (!response?.ContractStartDate || response?.ContractStartDate == '0001-01-01T00:00:00') {
          setAllModalData((prev) => ({ ...prev, ContractStartDate: getTodayFormatted() }));
        }
        if (!response?.ContractStartDate || response?.ContractStartDate == '0001-01-01T00:00:00') {
          setAllModalData((prev) => ({ ...prev, ContractStartDate: getTodayFormatted() }));
        }
        if (!response?.ContactTerm || response?.ContactTerm == 0) {
          setAllModalData((prev) => ({ ...prev, ContactTerm: 30 }));
        }
        if (!response?.ContactTermPeriod_Selected || response?.ContactTermPeriod_Selected == 0) {
          setAllModalData((prev) => ({ ...prev, ContactTermPeriod_Selected: response?.ContactTermPeriod_List[0] }));
        }
        if (!response?.ContractEndDate || response?.ContractEndDate == '0001-01-01T00:00:00') {
          setAllModalData((prev) => ({ ...prev, ContractEndDate: addPeriodToDate(getTodayFormatted(), 30, response?.ContactTermPeriod_List[0]?.DDLText) }));
        }
        if (!response?.TechnologyEnum || response?.TechnologyEnum == 0) {
          setAllModalData((prev) => ({ ...prev, TechnologyEnum: technologyEnum }));
        }
        if (!response?.ToolIcon) {
          setAllModalData((prev) => ({ ...prev, ToolIcon: tool?.ToolIcon }));
        }
        if (!response?.ToolId || response?.ToolId == 0) {
          setAllModalData((prev) => ({ ...prev, ToolId: tool?.IntegrationId }));
        }
        if (!response?.ToolName) {
          setAllModalData((prev) => ({ ...prev, ToolName: tool?.IntegrationName }));
        }
        if (!response?.CostCurrencyCode_Selected) {
          setAllModalData((prev) => ({ ...prev, CostCurrencyCode_Selected: response?.CurrencyCode_List?.find((f) => f.IsDefault) ?? response?.CurrencyCode_List[0] }));
        }
        if (!response?.PriceCurrencyCode_Selected) {
          setAllModalData((prev) => ({ ...prev, PriceCurrencyCode_Selected: response?.CurrencyCode_List?.find((f) => f.IsDefault) ?? response?.CurrencyCode_List[0] }));
        }
        if (!response?.TaxRates_Selected) {
          setAllModalData((prev) => ({ ...prev, TaxRates_Selected: response?.TaxRates?.find((f) => f.IsDefault) ?? response?.TaxRates[0] }));
        }
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
      setModalLoading(false);
    });
  }

  function createUpdateRecommendedToolByID() {
    const mspIdLocal = mspId ?? selectedMSP?.MSPId ?? 0;
    postData(authTokens, "CreateUpdateRecommendedToolById", {
      ObjId_Customer: mspIdLocal,
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      SecurityStackReportId: reportId ?? 0,
      SecurityStackReport_Json: JSON.stringify(allModalData ?? {}),
    })
      .then((response) => {
        if (response?.Success) {
          getPageData(mspIdLocal, reportId, true);
          CallToast("Updated successfully", false, false, "v2style");
          hideModal();
        } else {
          CallToast("Something went wrong", false, false, "v2style");
        }
      })
      .catch((err) => {
        CallToast("Something went wrong", false, false, "v2style");
        console.log(err);
      });
  }

  const deleteRecommendedTool = async () => {
    setIsDeleting(true);
    const mspIdLocal = mspId ?? selectedMSP?.MSPId ?? 0;
    postData(authTokens, "DeleteRecommendedToolById", {
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      SecurityStackReportId: reportId ?? 0,
      ToolUniqueId: allModalData?.ToolUniqueId,
    })
      .then((response) => {
        if (response?.Success) {
          getPageData(mspIdLocal, reportId, true);
          CallToast("Deleted successfully", false, false, "v2style");
          hideModal();
        } else {
          CallToast("Something went wrong", false, false, "v2style");
        }
      })
      .catch((err) => {
        CallToast("Something went wrong", false, false, "v2style");
        console.log(err);
      })
      .finally(() => {
        setIsDeleting(false);
      });
  }

  return (
    <SlidingModal
      show={show}
      parentID={"mainBody"}
      id="add-tool-modal-id"
      onHide={hideModal}
      className="sec-stack-add-tool-modal"
    >
      <SlidingModal.Header className="d-flex p-3 align-items-center justify-content-between border-bottom">
        <div></div>

        <div className="d-flex align-items-center gap-4">
          <ImageLoader
            src={integrationUtils.getImagePath(tool?.IntegrationId, tool?.ToolIcon)}
            alt=""
            width={16}
            height={16}
            className="radius-full"
            noImageComponent={(
              <img className='icon radius-full' src="/images/attack-surface/generic2-dark.svg" width={16} height={16} alt="" />
            )}
          />
          <span className="f-500 f-14 line-height-22 f-black">{tool?.IntegrationName || tool?.ToolName}</span>
        </div>

        <div className="pointer" onClick={hideModal}>
          <img src="/images/attack-surface/cross-icon.svg" alt="" />
        </div>
      </SlidingModal.Header>
      <SlidingModal.Body className="modal-body">
        {
          modalLoading ?
            <div className="d-flex align-items-center justify-content-center w-100"
              style={{ height: "85vh" }}
            >
              <OrderSummary />
            </div> : <>
              <div className="d-flex align-items-center justify-content-between gap-8">
                <div className="d-flex align-items-center gap-8">
                  <ImageLoader
                    src={integrationUtils.getImagePath(tool?.IntegrationId, tool?.ToolIcon)}
                    alt=""
                    width={16}
                    height={16}
                    className="radius-2"
                    noImageComponent={(
                      <img className='icon radius-2' src="/images/attack-surface/generic2-dark.svg" width={16} height={16} alt="" />
                    )}
                  />
                  <span className="f-500 f-14 line-height-22 f-black">{tool?.IntegrationName || tool?.ToolName}</span>
                </div>
                <Dropdown className='transparennt-wrapper-dropdown my-dropdown my-dropdown-common'>
                  <Dropdown.Toggle className="my-button">
                    <ThreeDotsIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="menu">
                    <div className="item f-red f-14 line-height-22 d-flex justify-content-between align-items-center gap-4" onClick={() => {
                      if (isDeleting) return;
                      deleteRecommendedTool();
                    }}>
                      <span>Delete</span>
                      {isDeleting && (
                        <Spinner
                          animation="border"
                          variant="secondary"
                          size="sm"
                          style={{
                            width: '14px',
                            height: '14px',
                          }}
                        />
                      )}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="d-flex flex-column gap-16">
                <div className="f-500 f-12 line-height-18 f-darkgrey">
                  Product Details
                </div>
                <ProductDetailsForm
                  allModalData={allModalData}
                  setAllModalData={setAllModalData}
                  multiTechnologyList={multiTechnologyList}
                  refreshTaxList={refreshTaxList}
                />
              </div>
            </>
        }
      </SlidingModal.Body>
      <SlidingModal.Footer className="p-3 position-sticky w-100 border-top">
        <div className="d-flex align-items-center justify-content-end gap-8">
          <button className="grey-button my-button" onClick={hideModal}>
            <span>Cancel</span>
          </button>
          <button className="blue-button my-button" onClick={createUpdateRecommendedToolByID}>
            <span>Save</span>
          </button>
        </div>
      </SlidingModal.Footer>
    </SlidingModal>
  )
}

export default AddToolModal;


export function getTodayFormatted() {
  const today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}T00:00:00`;
}